/**
 * Socket del operador (consola) — wrapper del RealtimeCore.
 * El token se reevalúa en cada (re)conexión (función de auth del core).
 */
import RealtimeCore from './realtimeCore';

let currentToken = null;
const core = new RealtimeCore('/operator', {
  getToken: () => currentToken
});

const socketOperator = {
  connect: (token) => {
    currentToken = token || currentToken;
    return core.connect();
  },
  on: (event, cb) => core.on(event, cb),
  off: (event, cb) => core.off(event, cb),
  joinCart: (cartId) => core.joinRoom(cartId),
  leaveCart: (cartId) => core.leaveRoom(cartId),
  requestSync: (cartIds) => core.emit('reconnect:request-sync', { cartIds }),
  onResync: (handler) => core.onResync(handler),
  onAuthError: (handler) => core.onAuthError(handler),
  disconnect: () => core.disconnect(),
  get connected() { return core.connected; }
};

export default socketOperator;
